import {
  FieldSection,
  FieldSectionTitle,
  FormContainer,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { formRoleConf } from "../details.formRoleConf"
import { HolderList } from "./HolderList"

export const Holder = () => {
  const conf = useRoleConf(formRoleConf)

  return (
    <FormContainer>
      <FieldSectionTitle title="Titulaires" />
      <FieldSection
        title="Titulaires"
        subtitle="Indiquer le(s) titulaire(s) de l'officine"
      >
        <HolderList initialConf={conf} />
      </FieldSection>
    </FormContainer>
  )
}
